export const decodeUrl = (url: string): string => {
  return decodeURIComponent(url.replace(/\+/g, ' '));
};

export const encodeUrl = (url: string): string => {
  return encodeURIComponent(url).replace(/'/g, '%27').replace(/"/g, '%22');
};
